import '@fortawesome/fontawesome-free/css/all.css'
import Vue from "vue";
import App from "./App.vue";
import VueMoment from "vue-moment";
import VueAnalytics from "vue-analytics";
import VueMeta from "vue-meta";
import posthog from 'posthog-js';
import { library } from "@fortawesome/fontawesome-svg-core";
import VueClipboard from 'vue-clipboard2'
import VueMasonry from 'vue-masonry-css'
import VueApexCharts from 'vue-apexcharts'

import VueTabulator from 'vue-tabulator';

import {
  faCoffee,
  faPlusCircle,
  faChartLine,
  faChevronDown,
  faMobile,
  faEnvelope,
  faClock,
  faUsers,
  faPaperPlane,
  faCheckCircle,
  faCheck,
  faLeaf,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import router from "./router";
import store from "./store";
import vuetify from './plugins/vuetify';
import { supabase } from '@/config/supabase';
import Vuetify from 'vuetify/lib'

import VueSweetalert2 from 'vue-sweetalert2';

import Gravatar from 'vue-gravatar';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

import VueFabric from 'vuejs-fabric';

let appName = 'Grid Rank'

// Initialize PostHog with hardcoded configuration
posthog.init(process.env.VUE_APP_POSTHOG_API_KEY, {
  api_host: process.env.VUE_APP_POSTHOG_HOST,
  autocapture: false,
  capture_pageview: false,
  disable_session_recording: true
})
Vue.prototype.$posthog = posthog;

if (window.location.origin != process.env.VUE_APP_MAIN_URL) {
  axios.get(`${process.env.VUE_APP_API_ENDPOINT}/agency/get-agency-details` + "?host=" + window.location.host).then(function(response) {
    if (response.data.success) {
      appName = response.data.agency.company_name

      Vue.use({
        install() {
          Vue.agency = response.data.agency;
          Vue.prototype.$agency = response.data.agency;
          Vue.appName = response.data.agency.company_name;
          Vue.prototype.$appName = response.data.agency.company_name;
        }
      });

      continueLoadingApp()
    }
    else {
      return "Not a valid domain."
    }
  });
}
else {
  Vue.use({
    install() {
      Vue.agency = null;
      Vue.prototype.$agency = null;
      Vue.appName = appName;
      Vue.prototype.$appName = appName;
    }
  });

  continueLoadingApp()
}

function continueLoadingApp() {
  let parent_id = '';
  let loggedIn = false;

  let vuex = {auth: {session: null}};

  try {
    vuex = JSON.parse(window.localStorage.vuex);
  }
  catch (e) {}

  // console.log('vuex', vuex)

  // Try to recover token from localStorage or session
  let token = null;
  if (vuex.auth && vuex.auth.session && vuex.auth.session.access_token) {
    token = vuex.auth.session.access_token;
  } else {
    token = localStorage.getItem('auth_token');
  }

  if (token) {
    axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/users/profile`, {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    }).then(function(response) {
      // console.log('response.data', response.data)
      parent_id = response.data.parent_id;
      loggedIn = true;
      // Store user data in vuex
      if (response.data) {
        vuex.auth.user = response.data;
      }
      continueLoadingApp2();
    }).catch(function (error) {
      // If token is invalid, clear it
      if (error.response && error.response.status === 401) {
        localStorage.removeItem('auth_token');
        if (vuex.auth) {
          delete vuex.auth.session;
        }
      }
      continueLoadingApp2();
    });
  }
  else {
    continueLoadingApp2();
  }
  
  function continueLoadingApp2() {
    library.add([
      faCoffee,
      faPlusCircle,
      faChartLine,
      faChevronDown,
      faMobile,
      faEnvelope,
      faClock,
      faUsers,
      faPaperPlane,
      faCheckCircle,
      faCheck,
      faLeaf,
    ]);

    Vue.use(VueMoment);
    Vue.use(VueMeta);
    Vue.component("font-awesome-icon", FontAwesomeIcon);

    Vue.component('v-gravatar', Gravatar);

    Vue.use(VueSweetalert2);

    Vue.use(VueClipboard)

    Vue.use(Vuetify)

    Vue.use(VueMasonry);

    Vue.use(VueApexCharts)

    Vue.component('apexchart', VueApexCharts)

    Vue.component('VueFabric',VueFabric);

    // Make BootstrapVue available throughout your project
    Vue.use(BootstrapVue)
    // Optionally install the BootstrapVue icon components plugin
    Vue.use(IconsPlugin)

    Vue.use(VueTabulator);

    Vue.use({
      install() {
          Vue.appName = appName;
          Vue.prototype.$appName = appName;
      }
    });

    new Vue({
      router
    });

    // Add request interceptor to automatically include token and refresh_token
    axios.interceptors.request.use(
      config => {
        const token = store.getters['auth/jwt'] ||
                      store.getters['auth/accessToken'] ||
                      localStorage.getItem('auth_token');

        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        }
        
        // Also send refresh_token for backend auto-refresh (only in non-embed mode)
        // Embed mode uses iframe JWT which doesn't have refresh_token
        const isEmbedMode = store.getters['embed/isEmbedMode'];
        if (!isEmbedMode) {
          const session = store.state.auth.session;
          if (session && session.refresh_token) {
            // Log session with readable expiration time
            const expiresAtReadable = session.expires_at
              ? new Date(session.expires_at * 1000).toLocaleString()
              : 'N/A';
            console.log(expiresAtReadable);
            config.headers['X-Refresh-Token'] = session.refresh_token;
          }
        }

        return config;
      },
      error => {
        return Promise.reject(error);
      }
    );

    axios.interceptors.response.use(
      response => {
        // Check if backend refreshed the token and sent new tokens in headers
        const newAccessToken = response.headers['x-new-access-token'];
        const newRefreshToken = response.headers['x-new-refresh-token'];
        
        if (newAccessToken && newRefreshToken) {
          console.log('🔄 Backend refreshed token - updating stored session');

          // Update stored session with new tokens
          const newSession = {
            access_token: newAccessToken,
            refresh_token: newRefreshToken,
            expires_at: Math.floor(Date.now() / 1000) + 3600, // 1 hour from now
            token_type: 'bearer'
          };

          store.commit('auth/setSession', newSession);

          // If in embed mode, also update embed token
          const isEmbedMode = store.getters['embed/isEmbedMode'];
          if (isEmbedMode) {
            store.commit('embed/setEmbedToken', newAccessToken);
          }
        }

        return response;
      },
      async function (error) {
        const originalRequest = error.config;

        // If we get a 401 - backend already tried to refresh if possible
        if (error.response && error.response.status === 401) {
          // Avoid infinite loops on login endpoint
          if (originalRequest.url && originalRequest.url.includes('/api/users/login')) {
            return Promise.reject(error);
          }

          // Check if we're in embed mode
          const isEmbedMode = store.getters['embed/isEmbedMode'];

          // In embed mode, try to request fresh token from parent (reactive fallback)
          if (isEmbedMode) {
            // console.log('❌ Token expired in embed mode - requesting from parent');

            // Only retry once to avoid infinite loops
            if (!originalRequest._embedRetry) {
              originalRequest._embedRetry = true;

              // Request fresh token from parent
              if (window.parent !== window) {
                window.parent.postMessage({
                  source: 'gridrank',
                  type: 'token_refresh_request',
                  timestamp: Date.now()
                }, '*');
              }

              // Wait for parent to send new token (via message listener in router.js)
              await new Promise(resolve => setTimeout(resolve, 1000));

              // Try to get updated token and retry request
              const newToken = localStorage.getItem('auth_token');
              if (newToken) {
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                return axios(originalRequest);
              }
            }

            // If retry failed or no token received, notify parent of auth failure
            window.parent.postMessage({
              source: 'gridrank',
              type: 'auth_failed',
              error: 'Authentication failed',
              timestamp: Date.now()
            }, '*');

            return Promise.reject(error);
          }

          // In normal mode - backend already tried to refresh - just logout
          // console.log('❌ Authentication failed - backend could not refresh token');

          await store.dispatch('auth/logout');
          router.push('/login');

          return Promise.reject(error);
        }

        return Promise.reject(error);
      }
    );

    // ===== DISABLED: Supabase auth state listener =====
    // Backend now handles token refresh automatically.
    //
    // This listener was causing logout on token expiry because:
    // 1. Supabase fires SIGNED_OUT when token expires
    // 2. This happens before backend can refresh the token
    // 3. Backend refresh is now seamless - no client-side listeners needed
    //
    // Logout is already handled in PanelNavigation.vue
    // ===== END DISABLED SECTION =====

    /*
    supabase.auth.onAuthStateChange(async (event, session) => {
      console.log('Auth state changed:', event);
      if (event === 'SIGNED_IN' || event === 'TOKEN_REFRESHED') {
        if (session) {
          store.commit('auth/setSession', session);
          const isEmbedMode = store.getters['embed/isEmbedMode'];
          if (isEmbedMode && session.access_token) {
            store.commit('embed/setEmbedToken', session.access_token);
          }
          const userData = {
            id: session.user.id,
            email: session.user.email,
            first_name: (session.user.user_metadata && session.user.user_metadata.first_name) || '',
            last_name: (session.user.user_metadata && session.user.user_metadata.last_name) || '',
            phone: (session.user.user_metadata && session.user.user_metadata.phone) || '',
            has_active_subscription: true
          };
          store.commit('auth/setUser', userData);
        }
      }
    });

    setInterval(async () => {
      const isAuthenticated = store.getters['auth/isAuthenticated'];
      if (isAuthenticated) {
        try {
          const { data: { session } } = await supabase.auth.getSession();
          if (session) {
            const expiresAt = session.expires_at ? new Date(session.expires_at * 1000) : null;
            const now = new Date();
            const thirtyMinutesFromNow = new Date(now.getTime() + 30 * 60000);
            if (expiresAt && expiresAt < thirtyMinutesFromNow) {
              console.log('Proactive token refresh triggered');
              await store.dispatch('auth/refreshToken');
            }
          }
        } catch (error) {
          console.error('Error in periodic token refresh check:', error);
        }
      }
    }, 30 * 60 * 1000);
    */

    // Plugins
    // ...

    // Sass file
    require("./assets/styles/main.css");

    Vue.config.productionTip = false;

    new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App)
    }).$mount("#app");
  }
}